import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useCreateSessionMutation, CreateSessionPayload } from '@/store/api/sessionsApi';
import { SessionForm } from './SessionForm';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useNotifications } from '@/hooks/useNotifications';

export function CreateSessionPage() {
  const navigate = useNavigate();
  const [createSession, { isLoading }] = useCreateSessionMutation();
  const { error: notifyError } = useNotifications();

  const handleSubmit = async (data: CreateSessionPayload) => {
    try {
      await createSession(data).unwrap();
      navigate('/sessions');
    } catch (err: any) {
      const message = err?.data?.message || 'Failed to create session. Please try again.';
      notifyError(Array.isArray(message) ? message.join('\n') : message);
    }
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-4">
        <Button variant="ghost" size="sm" onClick={() => navigate('/sessions')}>
          <ArrowLeft className="h-4 w-4 mr-1" /> Back
        </Button>
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Create Session</h1>
          <p className="text-muted-foreground">Add a new recorded session to the portal.</p>
        </div>
      </div>

      <SessionForm onSubmit={handleSubmit} isSubmitting={isLoading} submitLabel="Create Session" />
    </div>
  );
}
